import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { useLayoutContext } from '../../providers/LayoutProvider';
import { ReachButton } from '../ReachButton/ReachButton';
import { QuizCard } from './QuizCard';
import { QuizStepper } from './QuizStepper';
import './Quiz.scss';

export const Quiz = ({ quizConfig }) => {
    const { quizResults, setQuizResults } = useLayoutContext();
    const [config, setConfig] = useState(quizConfig);
    const numSteps = quizConfig.length - 1;
    const [currentStep, setCurrentStep] = useState(0);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (ready && currentStep < 4) {
            document.getElementById(`card-${currentStep}`).scrollIntoView({
                behavior: `auto`,
                block: `nearest`,
            });
        }
    }, [currentStep]);

    useEffect(() => {
        setReady(true);
    }, []);

    useEffect(() => {
        if (quizResults && Object.keys(quizResults)?.length > 1) {
            setCurrentStep(4);
        }
    }, [quizResults]);

    const onSubmit = (evt) => {
        evt.preventDefault();
        window[`dataLayer`] = window[`dataLayer`] || [];
        const results = config
            .map((item) => item.value)
            .reduce((result, current) => Object.assign(result, current), {});
        const { zipcode, ...dataLayerResults } = results;
        setQuizResults(results);
        if (typeof window !== `undefined`) {
            localStorage.setItem(`quizResults`, JSON.stringify(results));
            window[`dataLayer`].push({
                event: `quiz_question_4_completed`,
                quiz_response: dataLayerResults,
                form_name: `ad solution quiz`,
                quiz_marketer_type: results.brand,
            });
            navigate(`/your-solution`);
        }
    };

    if (!config.length) return null;

    return (
        <section className="kite-container quiz-container">
            <form
                className={`themed-container dark quiz kite-container ${
                    currentStep === 4 ? `complete` : ``
                }`}
                onSubmit={onSubmit}
            >
                <div>
                    <QuizStepper
                        currentStep={currentStep}
                        numSteps={numSteps}
                    />
                    <h2>{config[currentStep].heading}</h2>
                    {currentStep === 4 && (
                        <div>
                            <p className="typestack-body-1">
                                {config[currentStep].text}
                            </p>
                            <div className="buttons">
                                <ReachButton
                                    buttonStyle="secondary"
                                    onTouchStart={(evt) =>
                                        evt.cancelable && evt.preventDefault()
                                    }
                                    onClick={(evt) => {
                                        evt.preventDefault();
                                        (
                                            document.activeElement as HTMLElement
                                        ).blur();
                                        localStorage.removeItem(`quizResults`);
                                        setQuizResults({ none: true });
                                        setCurrentStep(0);
                                    }}
                                >
                                    Change Your Answers
                                </ReachButton>
                                <ReachButton
                                    buttonStyle="primary"
                                    buttonIcon={{
                                        icon: `ki-arrow-right`,
                                        position: `right`,
                                    }}
                                    href="/your-solution"
                                >
                                    View Your Solutions
                                </ReachButton>
                            </div>
                        </div>
                    )}
                </div>
                <ul>
                    {config.map((item, idx) => (
                        <QuizCard
                            mainHeading={item.heading}
                            first={idx === 0}
                            last={idx === config.length - 2}
                            title={item.cardTitle}
                            key={idx}
                            id={`card-${idx}`}
                            step={idx}
                            style={{
                                marginLeft: `${-100 * idx}%`,
                                marginRight: `${100 * idx}%`,
                                transform: `translateX(${100 * idx}%)`,
                            }}
                            valid={item.valid}
                            setCurrentStep={setCurrentStep}
                        >
                            <item.contents
                                config={config}
                                setConfig={setConfig}
                                idx={idx}
                                viewable={idx === 0 || config[idx - 1].valid}
                            />
                        </QuizCard>
                    ))}
                </ul>
            </form>
        </section>
    );
};
